import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchFirmModules, saveFirmModules } from "../api/firmModules";

// Admin-only read: the caller gates on role, and the flag keeps a
// non-admin mount from ever issuing the request.
export function useFirmModules(enabled: boolean) {
  return useQuery({
    queryKey: ["firm-modules"],
    queryFn: fetchFirmModules,
    staleTime: 60_000,
    enabled,
  });
}

export function useSaveFirmModules() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: saveFirmModules,
    onSuccess: (data) => {
      qc.setQueryData(["firm-modules"], data);
      // The chrome marks tiles and hides write controls from the identity's
      // module list - refetch it, or they lag the switch by up to five minutes.
      void qc.invalidateQueries({ queryKey: ["firm-identity"] });
    },
  });
}
